// Import React and the PropertiesSection component
import React from "react";
import ContactUsMain from "../components/contactus/contactmian";
import ContactInfo from "../components/contactus/contactinfo";
import Map from "../components/contactus/Map"
const Contact = () => {
  return (
   
    <div>

      {/* Include the PropertiesSection component */}
      <ContactUsMain/>
      <ContactInfo/>
      <Map/>
      </div>
  );
};

export default Contact;
